import {configureStore} from "@reduxjs/toolkit";

import {middleware} from "./middleware";
import {reducer} from "./reducer";

interface InitialState {}

export const makeStore = (initialState: InitialState) => {
    return configureStore({
        reducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
        devTools: true
    });
};
import {configureStore} from "@reduxjs/toolkit";

import {middleware} from "./middleware";
import {reducer} from "./reducer";

interface InitialState {}

export const makeStore = (initialState: InitialState) => {
    return configureStore({
        reducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
        devTools: true
    });
};
